import { useMutation, useQueryClient } from "@tanstack/react-query";
import { splitBooking, SplitBookingPayload, SplitBookingResponse } from "PFCore/services/split_booking";
import { MutationOptions } from "PFTypes/request_options";

import { useProfileInvalidate } from "../../profile";
import { bookingKeys } from "../query_keys";

export const useSplitBooking = ({ onSuccess, ...options }: MutationOptions<SplitBookingPayload>) => {
  const cache = useQueryClient();
  const { invalidateProfileWithBooking } = useProfileInvalidate();

  return useMutation(
    async (payload: SplitBookingPayload): Promise<SplitBookingResponse> => splitBooking(payload),
    {
      ...options,
      onSuccess: (data: SplitBookingResponse, ...args) => {
        const {
          existingBooking: { id }
        } = data;
        cache.invalidateQueries(bookingKeys.single(id));
        id && invalidateProfileWithBooking(id);
        onSuccess?.(data, ...args);
      }
    }
  );
};
